// Shared utility for occupancy type options used in InlineRoomForm and AddExtraDropdown

import { AssignmentType, GuestStructure } from "../types/accommodation.types";

export interface OccupancyOption {
  value: AssignmentType;
  label: string;
  available: boolean;
  personsPerRoom: number;
}

/**
 * Builds occupancy assignment options filtered by guest structure availability.
 * @param guestStructure - Current guest structure (pairs/singles/singlesAlone counts)
 * @param maxPersonsPerRoom - Maximum capacity of the room (used for singles_shared default)
 * @returns Array of occupancy options with availability flags
 */
export function buildOccupancyOptions(
  guestStructure: GuestStructure,
  maxPersonsPerRoom: number = 2
): OccupancyOption[] {
  return [
    {
      value: "pairs" as AssignmentType,
      label: "👫 Pary",
      available: guestStructure.pairs > 0,
      personsPerRoom: 2,
    },
    {
      value: "singles_shared" as AssignmentType,
      label: "👤 Single (dzielą)",
      available: guestStructure.singles > 0,
      personsPerRoom: maxPersonsPerRoom,
    },
    {
      value: "singles_alone" as AssignmentType,
      label: "👤 Single (prywatnie)",
      available: guestStructure.singlesAlone > 0,
      personsPerRoom: 1,
    },
  ];
}

/**
 * Returns only the available options from the full occupancy options list.
 */
export function getAvailableOccupancyOptions(
  guestStructure: GuestStructure,
  maxPersonsPerRoom: number = 2
): OccupancyOption[] {
  return buildOccupancyOptions(guestStructure, maxPersonsPerRoom).filter(
    (opt) => opt.available
  );
}
